import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { api } from '../../services/api'; // 引入我們的 API 服務

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(''); // 新增狀態來顯示成功或錯誤提示
  
  const { isAuthenticated } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || submitting) return;

    setSubmitting(true);
    setMessage('');
    
    try {
      // 呼叫真實後端 API
      await api.subscribeNewsletter(email);
      
      setEmail('');
      setSubscribed(true);
      setMessage('訂閱成功！');
      
      // 3 秒後恢復原狀
      setTimeout(() => {
        setSubscribed(false);
        setMessage('');
      }, 3000);
    } catch (error: any) {
      setMessage(error.message || '訂閱失敗，請稍後再試');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-star-dark text-white">
      <div className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-12">
          {/* Newsletter CTA */}
          <div>
            <h3 className="text-xl md:text-2xl font-heading font-semibold mb-4">
              加入序號寶庫
            </h3>
            <p className="text-white/60 text-sm leading-relaxed">
              訂閱我們的電子報，第一時間掌握最新遊戲特價與獨家折扣，再也不錯過任何好康！
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/40 mb-4">
              導覽
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  首頁
                </Link>
              </li>
              
              {isAuthenticated ? (
                <li>
                  <Link to="/member" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                    會員中心
                  </Link>
                </li>
              ) : (
                <li>
                  <Link to="/login" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                    會員登入
                  </Link>
                </li>
              )}
              
              <li>
                <Link to="/key-info" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  我的序號
                </Link>
              </li>
            </ul>
          </div>

          {/* Subscribe */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/40 mb-4">
              訂閱通知
            </h4>
            <p className="text-white/50 text-xs mb-3">
              輸入 Email 接收最新優惠
            </p>
            <form
              onSubmit={handleSubmit}
              data-readdy-form
              className="flex items-center gap-2 relative"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                disabled={submitting || subscribed}
                className="flex-1 bg-white/10 border border-white/10 rounded-full px-4 py-2.5 text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-white/30 transition-colors disabled:opacity-50"
              />
              <button
                type="submit"
                disabled={submitting || subscribed}
                className="w-10 h-10 rounded-full bg-white text-star-dark flex items-center justify-center hover:bg-white/90 transition-colors flex-shrink-0 cursor-pointer disabled:opacity-60"
              >
                {subscribed ? (
                  <i className="ri-check-line text-sm text-accent-mint"></i>
                ) : (
                  <i className="ri-arrow-right-line text-sm"></i>
                )}
              </button>
            </form>
            {/* 顯示提示訊息 */}
            {message && (
              <p className={`text-xs mt-2 ${subscribed ? 'text-accent-mint' : 'text-accent-rose'}`}>
                {message}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5 px-4 md:px-8 lg:px-12 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} Nice Game Steam Key Shop. All rights reserved.
          </p>
          <div className="text-[80px] md:text-[120px] font-heading font-bold text-white/[0.03] leading-none select-none pointer-events-none">
            STEAMKEYSALE
          </div>
        </div>
      </div>
    </footer>
  );
}